// Rochester Institute of Technology's majors (#2739). Read on 2026-10-01
// from RIT's official 2026-2027 Academic Catalog, Undergraduate Catalog,
// Colleges and Degree-Granting Units (academiccatalog.rit.edu), grouped by
// the college whose catalog page lists each program, with the degree as the
// catalog writes it. Humanities, Computing, and Design BS is listed by three
// colleges (Liberal Arts, Computing, Art and Design) and is shown once, under
// Liberal Arts. Physician Assistant is offered only as a five-year BS / MS dual
// degree, so it is listed with that degree. Left out: minors, immersions,
// certificates, associate degrees (AAS, AOS, AS), the other BS / MS and dual
// degree options, the exploration and undeclared starting points, the NTID
// pre-baccalaureate studies options and the Applied Arts and Sciences
// diploma.
const majors = {
    "slug": "rochester-institute-of-technology",
    "read": "2026-10-01",
    "intro": "Every bachelor's major in RIT's official 2026-2027 undergraduate catalog, grouped by the college that offers it. Minors, immersions, certificates, associate degrees, exploration programs and the optional BS / MS dual degrees are left out; Physician Assistant, offered only as a BS / MS, is included.",
    "groups": [
        {
            "name": "Kate Gleason College of Engineering",
            "source": {
                "label": "RIT Academic Catalog 2026-2027, Kate Gleason College of Engineering",
                "url": "https://academiccatalog.rit.edu/undergraduate-catalog/colleges-degree-granting-units/kate-gleason-college-engineering/"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Microelectronic Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Golisano College of Computing and Information Sciences",
            "source": {
                "label": "RIT Academic Catalog 2026-2027, Golisano College of Computing and Information Sciences",
                "url": "https://academiccatalog.rit.edu/undergraduate-catalog/colleges-degree-granting-units/golisano-college-computing-information-sciences/"
            },
            "majors": [
                {
                    "name": "Artificial Intelligence",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Computing and Information Technologies",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "BS"
                },
                {
                    "name": "Game Design and Development",
                    "degree": "BS"
                },
                {
                    "name": "Human-Centered Computing",
                    "degree": "BS"
                },
                {
                    "name": "New Media Interactive Development",
                    "degree": "BS"
                },
                {
                    "name": "Software Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Science",
            "source": {
                "label": "RIT Academic Catalog 2026-2027, College of Science",
                "url": "https://academiccatalog.rit.edu/undergraduate-catalog/colleges-degree-granting-units/college-science/"
            },
            "majors": [
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Applied Statistics and Data Analytics",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Bioinformatics and Computational Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biotechnology and Molecular Bioscience",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Computational Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Imaging Science",
                    "degree": "BS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Engineering Technology",
            "source": {
                "label": "RIT Academic Catalog 2026-2027, College of Engineering Technology",
                "url": "https://academiccatalog.rit.edu/undergraduate-catalog/colleges-degree-granting-units/college-engineering-technology/"
            },
            "majors": [
                {
                    "name": "Civil Engineering Technology",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering Technology",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering Technology",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Sustainability, Health and Safety",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering Technology",
                    "degree": "BS"
                },
                {
                    "name": "Mechatronics Engineering Technology",
                    "degree": "BS"
                },
                {
                    "name": "Packaging Science",
                    "degree": "BS"
                },
                {
                    "name": "Robotics and Manufacturing Engineering Technology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Art and Design",
            "source": {
                "label": "RIT Academic Catalog 2026-2027, College of Art and Design",
                "url": "https://academiccatalog.rit.edu/undergraduate-catalog/colleges-degree-granting-units/college-art-design/"
            },
            "majors": [
                {
                    "name": "3D Digital Design",
                    "degree": "BFA"
                },
                {
                    "name": "Film and Animation",
                    "degree": "BFA"
                },
                {
                    "name": "Graphic Design",
                    "degree": "BFA"
                },
                {
                    "name": "Illustration",
                    "degree": "BFA"
                },
                {
                    "name": "Industrial Design",
                    "degree": "BFA"
                },
                {
                    "name": "Interior Design",
                    "degree": "BFA"
                },
                {
                    "name": "Medical Illustration",
                    "degree": "BFA"
                },
                {
                    "name": "Motion Picture Science",
                    "degree": "BS"
                },
                {
                    "name": "New Media Design",
                    "degree": "BFA"
                },
                {
                    "name": "Photographic Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Photographic and Imaging Arts",
                    "degree": "BFA"
                },
                {
                    "name": "Studio Arts",
                    "degree": "BFA"
                }
            ]
        },
        {
            "name": "College of Liberal Arts",
            "source": {
                "label": "RIT Academic Catalog 2026-2027, College of Liberal Arts",
                "url": "https://academiccatalog.rit.edu/undergraduate-catalog/colleges-degree-granting-units/college-liberal-arts/"
            },
            "majors": [
                {
                    "name": "Advertising and Public Relations",
                    "degree": "BS"
                },
                {
                    "name": "Applied Modern Language and Culture",
                    "degree": "BS"
                },
                {
                    "name": "Communication",
                    "degree": "BS"
                },
                {
                    "name": "Criminal Justice",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BS"
                },
                {
                    "name": "Global Futures",
                    "degree": "BS"
                },
                {
                    "name": "History",
                    "degree": "BS"
                },
                {
                    "name": "Humanities, Computing, and Design",
                    "degree": "BS"
                },
                {
                    "name": "Museum Studies",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Sociology and Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Women's, Gender, and Sexuality Studies",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Saunders College of Business",
            "source": {
                "label": "RIT Academic Catalog 2026-2027, Saunders College of Business",
                "url": "https://academiccatalog.rit.edu/undergraduate-catalog/colleges-degree-granting-units/saunders-college-business/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS"
                },
                {
                    "name": "Finance",
                    "degree": "BS"
                },
                {
                    "name": "Global Business Management",
                    "degree": "BS"
                },
                {
                    "name": "Hospitality and Tourism Management",
                    "degree": "BS"
                },
                {
                    "name": "Management Information Systems",
                    "degree": "BS"
                },
                {
                    "name": "Marketing",
                    "degree": "BS"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Health Sciences and Technology",
            "source": {
                "label": "RIT Academic Catalog 2026-2027, College of Health Sciences and Technology",
                "url": "https://academiccatalog.rit.edu/undergraduate-catalog/colleges-degree-granting-units/college-health-sciences-technology/"
            },
            "majors": [
                {
                    "name": "Biomedical Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Diagnostic Medical Sonography (Ultrasound)",
                    "degree": "BS"
                },
                {
                    "name": "Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "Global Public Health",
                    "degree": "BS"
                },
                {
                    "name": "Nutritional Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Physician Assistant",
                    "degree": "BS / MS"
                }
            ]
        },
        {
            "name": "National Technical Institute for the Deaf",
            "source": {
                "label": "RIT Academic Catalog 2026-2027, National Technical Institute for the Deaf",
                "url": "https://academiccatalog.rit.edu/undergraduate-catalog/colleges-degree-granting-units/national-technical-institute-deaf/"
            },
            "majors": [
                {
                    "name": "ASL - English Interpretation",
                    "degree": "BS"
                },
                {
                    "name": "Community Development and Inclusive Leadership",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Individualized Study",
            "source": {
                "label": "RIT Academic Catalog 2026-2027, School of Individualized Study",
                "url": "https://academiccatalog.rit.edu/undergraduate-catalog/colleges-degree-granting-units/school-individualized-study/"
            },
            "majors": [
                {
                    "name": "Individualized Program",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
